export class DoiParser {
  private reg: RegExp;
  constructor() {
    this.reg = /\b(?:10[.][0-9]{4,}(?:[.][0-9]+)*\/(?:(?!["&\'<>])\S)+)\b/gi;
  }

  public parseIndex(str: string) {
    const indexes = [];
    let res = this.reg.exec(str);
    while (res !== null) {
      indexes.push([res.index, res.index + res[0].length]);
      res = this.reg.exec(str);
    }
    return indexes;
  }
}

export const isDoi = (str: string) => {
  return /\b(?:10[.][0-9]{4,}(?:[.][0-9]+)*\/(?:(?!["&\'<>])\S)+)\b/i.test(str);
};



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/services/parsers/doi-parser.ts